import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import LockedPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';
import { registerState } from '../../../../common/Services/RegistrationService.js';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const namespace = 'lockedPanel';
const FORM_ID = 'lockedPasswordForm';

import reducer from './redux/reducer';
import saga from './redux/sagas';

const store = getStore();

const createLockedScreen = () => {
  const root = createRoot(document.getElementById('lockedPanel'));
  if (isSupportedBrowser()) {
    registerState({
      namespace,
      reducers: reducer,
      sagas:    [saga],
    });

    root.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <LockedPanel />
        </AuthScreenLayout>
      </Provider>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createLockedScreen = createLockedScreen;
export { namespace, FORM_ID };
